module.exports = __webpack_public_path__ + "img/decorate.b889a6f9.svg";